module.exports = __webpack_public_path__ + "img/github-white.9483d227.svg";